import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NewSvideoContainerComponent } from './new-svideo-container.component';
import { PipesModule } from 'app/_pipes/pipes.module';
import { SimpleVideoplayerModule } from 'app/simple-videoplayer/simple-videoplayer.module';

@NgModule({
    declarations: [
        NewSvideoContainerComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        PipesModule,
        SimpleVideoplayerModule,
    ],
    exports: [
        NewSvideoContainerComponent,
    ]
})
export class NewSvideoContainerModule { }